import CompraAPI from "../../../api/compra";

const mixin = {
  methods: {
    async addProdutoFullNoCarrinho (produtos, completarCompra = false) {
      await this.$store.dispatch("loadingAux/habilitarLoading", true)

      const headers = this.Helpers.iniciarRequisicao()

      const columnObj = ['id_grupo', 'idproduto', 'idfornecedor']

      const params = {
        produtos: this.Helpers.arrayColumn(produtos, columnObj),
        completarCompra
      }

      await CompraAPI.addProdutoFullNoCarrinho(headers, params)
        .then((response) => {
          const { token } = response.data
          localStorage.setItem("token", token)
          this.$store.dispatch("loadingAux/habilitarLoading", false)
        })
        .catch(() => {
          this.$store.dispatch("loadingAux/habilitarLoading", false)
          this.Helpers.logout()
        })
    }
  }
}

export default mixin
